<script>
import { api } from "@/state/services";
import { formatDate } from "@/state/helpers/experiences";

// Últimos 5 clientes indicados (a API retorna em ordem crescente de data)
export default {
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
    };
  },
  methods: {
    formatDate,
    statusLabel(status) {
      const map = { active: "Ativo", inactive: "Inativo", pending: "Pendente" };
      return map[status] || status || "–";
    },
  },
  mounted() {
    api
      .get("clients")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          this.list = (response.data.list || []).slice(-5).reverse();
        } else {
          this.errored = true;
        }
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="font-size-15 mb-0">Últimos clientes</h5>
        <router-link to="/clients" class="font-size-13">Ver todos</router-link>
      </div>
      <div v-if="loading">
        <b-skeleton v-for="n in 3" :key="n" class="mb-2"></b-skeleton>
      </div>
      <p v-else-if="errored" class="text-muted mb-0">Não foi possível carregar os clientes agora.</p>
      <div v-else-if="list.length == 0" class="text-muted">
        Nenhum cliente indicado ainda.
        <router-link to="/clients/create">Indicar cliente</router-link>
      </div>
      <ul v-else class="list-unstyled mb-0">
        <li v-for="item in list" :key="item.id" class="d-flex justify-content-between align-items-center py-2 border-bottom">
          <div class="text-truncate mr-2">
            <div class="text-truncate">{{ item.name }}</div>
            <small class="text-muted">{{ formatDate(item.date) }}</small>
          </div>
          <span class="badge badge-light">{{ statusLabel(item.status) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
